import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Modal, Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as soldOutSizeModalStyle } from "./SoldOutSizeModal.style";

interface SoldOutSizeModalProps {
  readonly visible: boolean;
  readonly onClose: () => void;
  readonly onPressButton: () => void;
}

const SoldOutSizeModal: FC<SoldOutSizeModalProps> = ({ visible, onClose, onPressButton }) => {
  const style = useMemo(() => soldOutSizeModalStyle(), []);

  const productStockOutModalTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.PRODUCT_STOCK_OUT_MODAL_TITLE,
  });
  const productStockOutModalBodyText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.PRODUCT_STOCK_OUT_MODAL_BODY,
  });
  const productStockOutModalCtaText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.PRODUCT_STOCK_OUT_MODAL_CTA,
  });

  return (
    <Modal portalHostName="LookIn" visible={visible} showCloseButton onClose={onClose}>
      <View style={style.modalContent}>
        <Text level={3} style={style.title} variant="heading">
          {productStockOutModalTitleText}
        </Text>

        <Text style={style.bodyText}>{productStockOutModalBodyText}</Text>

        <Button testID="sold-out-press-button" onPress={onPressButton}>
          {productStockOutModalCtaText}
        </Button>
      </View>
    </Modal>
  );
};

export { SoldOutSizeModal };
